const players = new Map<string, HTMLVideoElement>();

const isPipSupported = (): boolean => typeof document !== "undefined" && document.pictureInPictureEnabled === true;

const playerFor = (src: string): HTMLVideoElement => {
  const existing = players.get(src);
  if (existing) return existing;
  const video = document.createElement("video");
  video.src = src;
  video.preload = "metadata";
  video.playsInline = true;
  video.setAttribute("aria-hidden", "true");
  Object.assign(video.style, {
    position: "fixed",
    left: "-10px",
    bottom: "0",
    width: "1px",
    height: "1px",
    opacity: "0",
    pointerEvents: "none",
  });
  video.addEventListener("leavepictureinpicture", () => video.pause());
  document.body.appendChild(video);
  players.set(src, video);
  return video;
};

export const preloadPip = (src: string | null): void => {
  if (src && isPipSupported()) playerFor(src);
};

export const playPip =(src: string | null): void => {
  if (!src || !isPipSupported()) return;
  const video = playerFor(src);
  players.forEach((other) => { if (other !== video) other.pause(); });
  video.currentTime = 0;
  video.play().catch(() => undefined);
  if (document.pictureInPictureElement !== video) video.requestPictureInPicture().catch(() => undefined);
};
